import { useMutation } from '@tanstack/react-query';
import apiClient from './api-client';
const saveDraftApplicantInfo = async (dto) => {
    const response = await apiClient.post(`/${dto.financingProgramId}/${dto.merchantId}/applicant/draft`, dto);
    return response.status.toString();
};
export function useSaveDraftApplicantInfo() {
    const { mutateAsync, isPending, isError, reset } = useMutation({
        mutationFn: saveDraftApplicantInfo,
    });
    return [mutateAsync, isPending, isError, reset];
}
